<template>
	<div class="days-months">
		<div class="days-months__item days-months__item--days">
			<span>{{ $t('components.booker.days_months.days_option') }}</span>
		</div>
		<NuxtLink :to="localePath('medium-term')" class="days-months__item days-months__item--months">
			<span>{{ $t('components.booker.days_months.months_option') }}</span>
		</NuxtLink>
	</div>
</template>

<script setup lang="ts">
const localePath = useLocalePath()
</script>

<style scoped lang="scss">
@import './DaysMonths.scss';
</style>
